module.exports = __webpack_public_path__ + "img/team-member-05.000a3d89.jpg";